// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3zcI-","label":"Radio_label__JwI2h","checkMark":"Radio_checkMark__cCAvN","disabled":"Radio_disabled__1apaV"};